import React, { useEffect, useState } from 'react'
import {
  List,
  Datagrid,
  TextField,
  TextInput,
  BooleanInput,
  useTranslate,
  useResourceContext,
  useResourceDefinitions,
  useListController,
  BooleanField,
  useStore,
} from 'react-admin'
import { Container } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { ListViewActionsButtons } from 'src/components/uiElements/buttons/ListViewActionsButtons'
import { ListViewTopToolbar } from 'src/components/uiElements/CRUD/ListViewTopToolbar'
import { getLoggedUser } from 'src/helper/localStore/getLoggedUser'

export const UserList = (props) => {
  const translate = useTranslate()
  const { setSort, isFetching } = useListController()
  const [isSorting, setIsSorting] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const loggedUser = getLoggedUser()
  const [permissionsStore, setPermissionsStore] = useStore('currentResource', '{}')
  const [permissions, setPermissions] = useState(null)
  const propsResource = useResourceDefinitions()
  const resourceName = useResourceContext()

  useEffect(() => {
    setPermissionsStore(JSON.stringify(propsResource[resourceName]))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propsResource, resourceName])

  useEffect(() => {
    if (permissionsStore) {
      setPermissions(JSON.parse(permissionsStore))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permissionsStore])

  useEffect(() => {
    if (isSorting && isFetching) {
      setIsLoading(true)
    } else if (isLoading && isSorting && !isFetching) {
      setIsLoading(false)
      setIsSorting(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSorting, isFetching])

  const onClickSort = (sort) => {
    setSort(sort)
    setIsSorting(true)
  }

  const hasPermissions = () => {
    return (
      permissions?.options?.revision ||
      permissions?.hasShow ||
      permissions?.hasEdit ||
      permissions?.options?.delete
    )
  }

  const userFilters = [
    <TextInput label={translate('ra.field.id')} source='id' defaultValue='' />,
    <TextInput label={translate('ra.field.firstname')} source='firstname' defaultValue='' />,
    <TextInput label={translate('ra.field.surname')} source='surname' defaultValue='' />,
    <TextInput label={translate('ra.field.username')} source='username' defaultValue='' />,
    <TextInput label={translate('ra.field.email')} source='mail' defaultValue='' />,
    <BooleanInput label={translate('ra.field.is_active')} source='is_active' defaultValue={true} />,
    <BooleanInput label={translate('ra.field.is_staff')} source='is_staff' defaultValue={false} />,
    <BooleanInput label={translate('ra.field.is_admin')} source='is_admin' defaultValue={false} />,
    ...(loggedUser?.is_superadmin
      ? [
          <BooleanInput
            label={translate('ra.field.is_superadmin')}
            source='is_superadmin'
            defaultValue={false}
          />,
        ]
      : []),
  ]

  const getStaffField = () => {
    return (
      loggedUser?.is_superadmin && <BooleanField label={translate('ra.field.is_staff')} source='is_staff' />
    )
  }

  const getAdminField = () => {
    return (
      (loggedUser?.is_admin || loggedUser?.is_superadmin) && (
        <BooleanField label={translate('ra.field.is_admin')} source='is_admin' sortable={false} />
      )
    )
  }

     
  const getSuperadminField = () => {
    return (
      loggedUser?.is_superadmin && (
        <BooleanField label={translate('ra.field.is_superadmin')} source='is_superadmin' />
      )
    )
  }

  return (
    <Container className='content'>
      <CardCommon title={translate('ra.entity.user')}>
        <List
          {...props}
          component='div'
          filters={userFilters}
          actions={<ListViewTopToolbar hasCreate={permissions?.hasCreate} />}
        >
          <Datagrid rowClick='show' setSort={onClickSort} isLoading={isLoading}>
            <TextField label={translate('ra.field.id')} source='id' />
            <TextField label={translate('ra.field.firstname')} source='firstname' />
            <TextField label={translate('ra.field.surname')} source='surname' />
            <TextField label={translate('ra.field.username')} source='username' />
            {getStaffField()}
            {getAdminField()}
            {getSuperadminField()}
            {hasPermissions() && (
              <ListViewActionsButtons
                label={translate('ra.field.action')}
                actionDisable
                fieldsName={['firstname', 'surname']}
                genderElement='masculine'
              />
            )}
          </Datagrid>
        </List>
      </CardCommon>
    </Container>
  )
}
